module.exports = {
  "country": "IL",
  "artist": "Nadav Guedj",
  "song": "Golden Boy",
  "year": "2015",
  "place": "9",
  "spotify": "3r7u0wAtogHrYSEiM9OlOY"
};